import React, { useState } from "react"

// Define default state for the context
const defaultState = {
  employeeOnlyFilter: false,
  userInfo: null,
  userLoaded: false,
}

export const userContext = React.createContext(defaultState)

const ContextProvider = props => {
  const [employeeOnlyFilter, setEmployeeOnlyFilter] = useState(
    defaultState.employeeOnlyFilter
  )
  const [userInfo, setUserInfo] = useState(defaultState.userInfo)
  const [userLoaded, setUserLoaded] = useState(defaultState.userLoaded)
  const [employeeChecked, setEmployeeChecked] = useState(false)
  const [loggedIn, setLoggedIn] = useState(false)

  return (
    <userContext.Provider
      value={{
        userInfo,
        setUserInfo,
        userLoaded,
        setUserLoaded,
        employeeOnlyFilter,
        setEmployeeOnlyFilter,
        employeeChecked,
        setEmployeeChecked,
        loggedIn,
        setLoggedIn,
      }}
    >
      {props.children}
    </userContext.Provider>
  )
}

const returner = ({ element }) => <ContextProvider>{element}</ContextProvider>

export default returner
